import { create } from 'zustand';
import { PaginationType } from '../types/pagination';
import {
  deleteTagStaff,
  fetchTagStaff,
  FetchTagStaffRequest,
  postTagStaff,
} from './api/tag-staff-api';
import { useAlertStore } from './use-alert-store';
import { IdValue } from '../types/props';

interface ManagerTagStaffStore extends Partial<PaginationType> {
  fetchTags: (params?: FetchTagStaffRequest) => Promise<void>;
  postTag: (name: string) => Promise<void>;
  deleteTag: (id: string) => Promise<void>;
  isLoading?: boolean;
  tags?: IdValue[];
}

export const useTagStaffStore = create<ManagerTagStaffStore>((set, get) => ({
  fetchTags: async () => {
    set({ isLoading: true });
    try {
      const resp = await fetchTagStaff();
      set({ tags: resp.tag });
    } catch (e) {
      console.error(e);
    } finally {
      set({ isLoading: false });
    }
  },
  postTag: async (name) => {
    set({ isLoading: true });
    try {
      await postTagStaff(name);
      useAlertStore.getState().add({ label: 'Должность успешно добавлена', variant: 'success' });
      await get().fetchTags({is_by_company: true, n: 1000, since_id: 0});
    } catch (e) {
      console.error(e);
      useAlertStore
        .getState()
        .add({ label: 'Не удалось сохранить данные по должности', variant: 'danger' });
    } finally {
      set({ isLoading: false });
    }
  },
  deleteTag: async (id) => {
    set({ isLoading: true });
    try {
      await deleteTagStaff(id);
      useAlertStore.getState().add({ label: 'Должность успешно удалена', variant: 'success' });
      set((store) => ({ ...store, tags: store.tags?.filter((item) => String(item.id) !== id) }));
    } catch (e) {
      console.error(e);
      useAlertStore.getState().add({ label: 'Не удалось удалить должность', variant: 'danger' });
    } finally {
      set({ isLoading: false });
    }
  },
}));
